export default function formateNumber(num = 0) {
  return Number(num).toLocaleString('en-IN');
}
